﻿import { onLoad } from 'runtime';
import { readFileAsDataURL } from 'utils';

onLoad(context => {
    context.querySelectorAll('input[type="file"]').forEach(element => {
        element.addEventListener('change', async () => {
            // Add the dimensions to the image (this is needed as we need to retrieve these asynchronously and jquery validate doesn't allow us to add custom async validation).
            const dimensions = [];

            for (let i = 0; i < element.files.length; i++) {
                const file = element.files[i];

                // Make sure the file is an image (also add an item if not an image so the length of element.files matches element.dataset.dimensions).
                if (file.type.startsWith('image')) {
                    const data = await readFileAsDataURL(file);
                    dimensions.push(await getImageDimensions(data));
                } else
                    dimensions.push({});
            }

            element.dataset.dimensions = JSON.stringify(dimensions);
        });

        // This makes sure this component is reset when the reset event is triggered against any parent element (not just a form). See https://jsfiddle.net/ojq0crft/ for why we specify true at the end.
        document.addEventListener('reset', e => {
            // If the target contains the element then reset it back to it's original text.
            if (e.target.contains(element))
                element.value = '';
        }, true);
    });
});

function getImageDimensions(src) {
    return new Promise((resolve, reject) => {
        const image = new Image();

        image.onload = () => {
            resolve({
                width: image.width,
                height: image.height
            });

            window.URL.revokeObjectURL(image.src); // Free up some memory.
        };

        image.onerror = reject;
        image.src = src;
    });
}